"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BORDER_RADIUS = 10;
//# sourceMappingURL=info-pane.constants.js.map